import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceOverview from "./sections/ServiceOverview";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceOverview />
      <FAQ />
      <Footer />
    </div>;
}